export default __webpack_public_path__ + "static/media/Lightning.3e183b37.svg";